import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment.prod';

@Component({
    selector: 'com-app-version',
    templateUrl: './com-app-version.component.html',
    styles: [],
})
export class ComAppVersionComponent implements OnInit {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public year: any = new Date().getFullYear();
    public version: string = environment.VERSION;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
    ngOnInit() {}
}
